function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getStateFromPath, useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import { useRef, useState } from "react";
import { Linking } from "react-native";
import { SystemBars } from "react-native-edge-to-edge";
import { useAppContext } from "../components/AppContext";
import { AuthScreenContainer } from "../components/AuthScreenContainer";
import { Button } from "../components/Button";
import { ErrorPresenter } from "../components/ErrorPresenter";
import { Link } from "../components/Link";
import { Text } from "../components/Text";
import { EmailInput, TextInput } from "../components/TextInput";
import { View } from "../components/View";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useForm } from "../hooks/useForm";
import { useLogout } from "../hooks/useLogout";
import { authClient } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { firebaseErrors, isFirebaseErrorKey } from "../lib/isFirebaseErrorKey";
import { parseUrl } from "../lib/parseUrl";
import Sentry from "../sentry";
import { useTheme } from "../styles";
/**
 * Login screen that allows users to create a new user session with a valid
 * email/password.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-143}
 */ export function Login() {
    var _props_route_params;
    var theme = useTheme().theme;
    // prefer hooks over component props because createSwitchNavigator from @rn/compat doesn't pass
    // the new param shape down to screens and in the staff app we navigate directly here instead
    // of a "Welcome" screen"
    var navigation = useNavigation();
    var route = useRoute();
    var props = {
        navigation: navigation,
        route: route
    };
    var isLoggedIn = useCurrentUser().isLoggedIn;
    var _useState = _sliced_to_array(useState(false), 2), isLoggingIn = _useState[0], setIsLoggingIn = _useState[1];
    var isFocused = useIsFocused();
    var appContext = useAppContext();
    var isLoggedInRef = useRef(false);
    isLoggedInRef.current = isLoggedIn;
    var _useForm = useForm({
        email: '',
        password: ''
    }), bind = _useForm.bind, data = _useForm.data, clear = _useForm.clear, validate = _useForm.validate, humanErrors = _useForm.humanErrors;
    var _useState1 = _sliced_to_array(useState(''), 2), errorCode = _useState1[0], setErrorCode = _useState1[1];
    var logout = useLogout();
    var $t = useI18n().$t;
    var emailInputRef = useRef(null);
    var passwordInputRef = useRef(null);
    var onLogin = function() {
        setErrorCode('');
        if (!validate()) return;
        setIsLoggingIn(true);
        var promise = authClient.login(data.email.trim(), data.password);
        return promise.then(function() {
            clear();
        }).catch(function(e) {
            if (_instanceof(e, Error)) {
                setErrorCode(e.message);
            }
            Sentry.captureException(e);
        }).then(function() {
            return Linking.getInitialURL();
        }).then(function(initialURL) {
            var parsedUrl = parseUrl(initialURL);
            var initialURLState = !process.env.STORYBOOK_CLIENT && (parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.path) ? getStateFromPath(parsedUrl.pathWithQuery, appContext.deeplinkConfig) : undefined;
            setIsLoggingIn(false);
            if ((parsedUrl === null || parsedUrl === void 0 ? void 0 : parsedUrl.isDeeplink) && !parsedUrl.isAuthDeeplink && initialURLState) {
                function attemptNavigation() {
                    // ensure react navigation mounts logged in screens before we
                    // attempt to navigate
                    if (isLoggedInRef.current) {
                        // @ts-expect-error type isn't refined enough but is correct
                        navigation.reset(initialURLState);
                    } else {
                        setTimeout(function() {
                            attemptNavigation();
                        }, 20);
                    }
                }
                attemptNavigation();
            }
        });
    };
    var errorString = errorCode ? isFirebaseErrorKey(errorCode) ? $t(firebaseErrors[errorCode]) : errorCode : undefined;
    return /*#__PURE__*/ _jsxs(AuthScreenContainer, {
        testID: "Login",
        heading: $t({
            id: 'Login_heading',
            defaultMessage: 'Welcome back'
        }),
        children: [
            isFocused ? /*#__PURE__*/ _jsx(SystemBars, {
                style: "dark"
            }) : null,
            /*#__PURE__*/ _jsx(ErrorPresenter, {
                formErrors: humanErrors,
                errorString: errorString,
                style: {
                    marginBottom: 10
                }
            }),
            /*#__PURE__*/ _jsxs(View, {
                spacing: 10,
                style: {
                    flexGrow: 1
                },
                children: [
                    ((_props_route_params = props.route.params) === null || _props_route_params === void 0 ? void 0 : _props_route_params.resetPassword) === 'true' ? /*#__PURE__*/ _jsx(Text, {
                        text: $t({
                            id: 'Login_passwordResetHint',
                            defaultMessage: 'Password reset successfully. Please log in.'
                        }),
                        testID: "Login_passwordResetHint",
                        color: theme.color.success,
                        textAlign: "center"
                    }) : null,
                    /*#__PURE__*/ _jsx(View, {
                        children: /*#__PURE__*/ _jsx(EmailInput, _object_spread_props(_object_spread({}, bind('email', {
                            label: $t({
                                id: 'Login_emailLabel',
                                defaultMessage: 'Email'
                            }),
                            validator: {
                                type: 'email'
                            }
                        })), {
                            enterKeyHint: "next",
                            testID: "Login_email",
                            ref: emailInputRef,
                            onSubmitEditing: function() {
                                var _passwordInputRef_current;
                                return (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
                            }
                        }))
                    }),
                    /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({
                        secureTextEntry: true,
                        placeholder: $t({
                            id: 'Login_passwordPlaceholder',
                            defaultMessage: 'Password'
                        }),
                        autoComplete: "current-password"
                    }, bind('password', {
                        label: $t({
                            id: 'Login_passwordLabel',
                            defaultMessage: 'Password'
                        })
                    })), {
                        enterKeyHint: "done",
                        ref: passwordInputRef,
                        onSubmitEditing: function() {
                            return void onLogin();
                        },
                        testID: "Login_password",
                        error: errorString
                    })),
                    /*#__PURE__*/ _jsx(Link, {
                        testID: "Login_forgotPassword",
                        onPress: function() {
                            if (authClient.getIsLoggedIn()) {
                                // logout doesn't reject
                                void logout().then(function() {
                                    setTimeout(function() {
                                        props.navigation.navigate('RequestResetPassword', {});
                                    }, 100);
                                });
                            } else {
                                props.navigation.navigate('RequestResetPassword', {});
                            }
                        },
                        style: {
                            marginLeft: 10
                        },
                        text: $t({
                            id: 'Login_forgotPasswordButton',
                            defaultMessage: 'Forgot password?'
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onPress: onLogin,
                        loading: isLoggingIn,
                        disabled: !data.password || !data.email,
                        alignSelf: "flex-end",
                        iconRight: "arrow-right",
                        testID: "Login_submit",
                        text: $t({
                            id: 'Login_loginButton',
                            defaultMessage: 'Login'
                        })
                    })
                ]
            })
        ]
    });
}
